type BeaconFn = ((method: string, options?: unknown, data?: unknown) => void) & {
  readyQueue: Array<{method: string; options?: unknown; data?: unknown}>;
};

declare global {
  interface Window {
    Beacon?: BeaconFn;
  }
}

function loadBeaconScript() {
  const firstScript = document.getElementsByTagName('script')[0];
  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.async = true;
  script.src = 'https://beacon-v2.helpscout.net';
  firstScript?.parentNode?.insertBefore(script, firstScript);
}

export function loadHelpScout() {
  const beacon: BeaconFn = ((method: string, options?: unknown, data?: unknown) => {
    beacon.readyQueue.push({method, options, data});
  }) as BeaconFn;
  beacon.readyQueue = [];
  window.Beacon = beacon;

  if (document.readyState === 'complete') {
    loadBeaconScript();
  } else {
    window.addEventListener('load', loadBeaconScript, {once: true});
  }
}
